export default "__VITE_ASSET__LDg7K8rW__"